import styled from '@emotion/styled'
import { Carousel } from 'antd'

export const CarouselSwipeNoDnd = styled(Carousel)`
  background: #fff;
`
